module.exports = __webpack_public_path__ + "img/3.bd7bd31b.jpg";